import { Helmet } from 'react-helmet';

// title - page title
// favicon - png image used for favicon in browser tab
// description - 150 characters for seo, 200 for social media
// image - 1200 x 630 with 1024 x 512 safe area for twitter
// url - full page url (ex. https://realmroyale.com/battle-pass)
// twitter - twitter handle for ip (ex. @smitegame)

const MetaInformation = (props) => {
	const { title, favicon, description, image, url, twitter } = props;
	return (
		<Helmet>
			<title>{title}</title>
			<link rel="icon" type="image/png" href={favicon} />
			<meta name="description" content={description} />
			<meta name="image" content={image} />
			<meta itemprop="name" content={title} />
			<meta itemprop="description" content={description} />
			<meta itemprop="image" content={image} />
			<meta name="twitter:card" content={description} />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:site" content={twitter} />
			<meta name="twitter:image:src" content={image} />
			<meta name="og:title" content={title} />
			<meta name="og:description" content={description} />
			<meta name="og:image" content={image} />
			<meta name="og:url" content={url} />
			<meta name="og:site_name" content={title} />
			<meta name="og:type" content="website" />
		</Helmet>
	);
};

export default MetaInformation;


// WEBPACK FOOTER //
// ./components/MetaInformation.js